import { render } from "./flash.vue?vue&type=template&id=4b2584d4"
import script from "./flash.js?vue&type=script&lang=js"
export * from "./flash.js?vue&type=script&lang=js"

import "./flash.vue?vue&type=style&index=0&id=4b2584d4&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__